module.exports = __webpack_public_path__ + "static/img/4.a3db1c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/4.jpg
// module id = dGPU
// module chunks = 25